/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseTextarea from 'shared/ui/components/form-components/BaseTextarea.vue';
import { isEmpty, isEqual } from 'lodash';

const __vue_script__ = {
    name: 'MetadataEditChoiceList',

    components: { BaseTextarea },

    props: {
        categoryIndex: {
            type: Number,
            required: true,
        },
        fieldIndex: {
            type: Number,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        values: {
            type: Object,
            default: () => {},
        },
        valuesOrder: {
            type: Object,
            default: () => {},
        }
    },

    data() {
        return {
            editMode: false,
            innerValue: '',
            showEdit: !this.disabled,
            unchangedValue: '',
            warningExpanded: false,
        };
    },

    computed: {
        warningToggleText() {
            return this.warningExpanded ? this.$t('general.show_less') : this.$t('general.show_more');
        }
    },

    created() {
        this.computeTextAreaFromValues(this.values, this.valuesOrder);
    },

    methods: {
        allowEdit() {
            this.editMode = true;
            this.unchangedValue = this.innerValue;
            if (this.innerValue === '') {
                this.innerValue = '• ';
            }
        },

        cancelEdit() {
            this.editMode = false;
            this.innerValue = this.unchangedValue;
            this.unchangedValue = '';
        },

        /**
         * @param {Record<string,string>} values
         * @param {Record<string,number>} valuesOrder
         */
        computeTextAreaFromValues(values, valuesOrder) {
            const valueDisplay = (value, label) => `• ${label} (key='${value}')`;
            const tempArray = [];
            if (!isEmpty(valuesOrder)) {
                for (const value in valuesOrder) {
                    tempArray[valuesOrder[value]] = valueDisplay(value, values[value]);
                }
            } else {
                for (const value in values) {
                    tempArray.push(valueDisplay(value, values[value]));
                }
            }
            this.innerValue = tempArray.join('\n');
        },

        saveEdit() {
            this.editMode = false;
            const values = {};
            const valuesOrder = {};
            const keyRegexp = /^(.*)\(key='(.*)'\)$/;

            let i = 0;
            for (let d of this.innerValue.split('\n')) {
                const line = d.replace(/^•/, '').trim();
                if (line === '') { continue; }
                const matchResult = keyRegexp.exec(line);
                let value = line;
                let label = line;
                if (matchResult !== null) {
                    value = matchResult[2].trim();
                    label = matchResult[1].trim();
                }

                if (!values[value]) {
                    values[value] = label;
                    valuesOrder[value] = i;
                    i++;
                }
            }

            this.computeTextAreaFromValues(values, valuesOrder);

            this.unchangedValue = '';

            if (!isEqual(this.values, values) || !isEqual(this.valuesOrder, valuesOrder)) {
                this.$store.commit('updateMetadataField', {
                    categoryIndex: this.categoryIndex,
                    fieldIndex: this.fieldIndex,
                    path: ['definition', 'kind_options'],
                    value: { values, values_order: valuesOrder },
                });
            }
        },

        onKeyDown(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                const element = e.target;
                const start = element.selectionStart;
                element.value = element.value.slice(0, start) + '\n• ' + element.value.slice(start);
                element.selectionStart = start + 3;
                element.selectionEnd = start + 3;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metadata-edit-choice-list-container"},[_c('div',{staticClass:"metadata-edit-choice-list"},[_c('base-textarea',{attrs:{"disabled":!_vm.editMode,"name":("choice-" + _vm.categoryIndex + "-" + _vm.fieldIndex)},on:{"keydown":function($event){return _vm.onKeyDown($event)}},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}}),(!_vm.disabled)?_c('div',{staticClass:"buttons"},[(_vm.showEdit && !_vm.editMode)?_c('a',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.allowEdit.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('metadata_editor.edit_choice_list')))]):[_c('button',{staticClass:"btn btn-mini btn-icon single btn-success",attrs:{"type":"button"},on:{"click":_vm.saveEdit}},[_c('i',{staticClass:"ic-check"})]),_c('button',{staticClass:"btn btn-mini btn-icon single btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancelEdit}},[_c('i',{staticClass:"ic-x"})])]],2):_vm._e()],1),_c('div',{staticClass:"alert alert-info"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('metadata_editor.choice_list_details.alert.title')))])]),(_vm.warningExpanded)?_c('p',[_vm._v(_vm._s(_vm.$t('metadata_editor.choice_list_details.alert.message'))+" "),_c('a',{attrs:{"href":"https://support.spotme.com/hc/en-us/articles/34643855803795-Using-the-Metadata-manager#h_01H2DNR15R7V2DXVEJTCGVKAB5","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.$t('metadata_editor.choice_list_details.alert.link')))])]):_vm._e(),_c('a',{staticClass:"toggle",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.warningExpanded = !_vm.warningExpanded}}},[_vm._v(_vm._s(_vm.warningToggleText)),(_vm.warningExpanded)?_c('i',{staticClass:"ic-chevron-up"}):_c('i',{staticClass:"ic-chevron-down"})]),_c('p')])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MetadataEditChoiceList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__